import { Component, OnInit } from '@angular/core';
import { MenuService } from 'src/app/services/menu.service';
import { Router, RouterOutlet } from '@angular/router';
import { Observable } from 'rxjs';
import { slideFadeinUp, slideFadeinRight, zoomFadein, fadein } from '../App/router-animations';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-layout-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.scss'],
  animations: [slideFadeinUp, slideFadeinRight, zoomFadein, fadein],
})
export class LayoutSettingComponent implements OnInit {
  routerAnimation: string;

  constructor() {
    this.routerAnimation = 'fadein';
  }

  ngOnInit() {}

  routeAnimation(outlet: RouterOutlet, animation: string) {
    if (animation === this.routerAnimation) {
      return outlet.isActivated && outlet.activatedRoute.routeConfig.path;
    }
  }
  changeOfRoutes() {}
}
